"use strict";

import {preloadSlide} from "./slider";
import {onEnterViewPort} from "../libs/@elements/viewport-utils";

let sliderId = 0;

export function initInScope($scope) {
    let $thumbSlider = $scope.find('.js-gallery-slider');

    import('slick-carousel').then(function () {
        $thumbSlider.each(function () {
            let $container = $(this);
            let $mainSlider = $container.find('.js-gallery-slider__main');
            let $thumbSlider = $container.find('.js-gallery-slider__thumbs');
            let id = sliderId++;

            $mainSlider.attr('id', 'main-slider__main-' + id);
            $thumbSlider.attr('id', 'thumb-slider__thumb-' + id);

            $mainSlider.on('afterChange', function (event, slick, currentSlide) {
                preloadSlide(slick, currentSlide + (matchMedia('(max-width: 767px)').matches ? 2: 1));
            }).slick({
                asNavFor: '#thumb-slider__thumb-' + id,
                dots: true,
                prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><i class='icon icon-button-arrow'></i></button>",
                nextArrow:"<button type='button' class='slick-next' aria-label='next'><i class='icon icon-button-arrow'></i></button>",
                infinite: false,
                responsive: [{
                    breakpoint: 991,
                    settings: {
                        asNavFor: null,
                        slidesToShow: 1,
                    }
                }]
            }).each(function () {
                let $slider = $(this);
                onEnterViewPort($slider, function () {
                    preloadSlide(
                        $slider.slick('getSlick'),
                        (matchMedia('(max-width: 767px)').matches ? 2: 1)
                    );
                });
            });

            if ($thumbSlider && $thumbSlider.length) {
                $thumbSlider.slick({
                    dots: true,
                    arrows:false,
                    infinite: false,
                    asNavFor: '#main-slider__main-' + id,
                    focusOnSelect: true,
                    slidesToShow: $thumbSlider.data('slider-items') || 4
                });
            }
        });
    });
}